import React, { useState, useEffect, useCallback } from "react";
import styles from "../CompletedInvoiceModal.module.css";
import CustomSelect from '../../../customComponents/CustomSelect';
import { API_URL } from '../../../config/api';
import axios from "axios";

const CompletedInvoiceModal = ({ open, onClose, onPay, onPayLater, warehouseId }) => {
  const token = localStorage.getItem("token");

  const [suppliers, setSuppliers] = useState([]);
  const [wallets, setWallets] = useState([]);
  const [shifts, setShifts] = useState([]);

  const [supplierId, setSupplierId] = useState(null);
  const [paymentMethodId, setPaymentMethodId] = useState(null);
  const [shiftId, setShiftId] = useState(null);

  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [, setLoading] = useState(false);

  const fetchSuppliers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/contractors?type=supplier`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSuppliers(res.data?.data || []);
    } catch (err) {
      console.error("Ошибка загрузки поставщиков:", err);
      setSuppliers([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const fetchWallets = useCallback(async () => {
    if (!warehouseId) return;
    setLoading(true);
    try {
        const resCash = await axios.get(
        `${API_URL}/api/wallets?storage_id=${warehouseId}&type=cash`,
        { headers: { Authorization: `Bearer ${token}` } }
        );

        const resCard = await axios.get(
        `${API_URL}/api/wallets?type=card`,
        { headers: { Authorization: `Bearer ${token}` } }
        );

        const walletsData = [...(resCash.data?.data || []), ...(resCard.data?.data || [])];

        const formattedWallets = walletsData.map(w => ({
        value: w.id,
        label: w.type === "card"
            ? `${w.bank_name || "Без банка"} - ${parseFloat(w.balance || 0).toLocaleString()} ₸`
            : `${w.storage || "Без склада"} - ${parseFloat(w.balance || 0).toLocaleString()} ₸`,
        }));

        setWallets(formattedWallets);
    } catch (err) {
        console.error("Ошибка загрузки wallets:", err);
        setWallets([]);
    } finally {
        setLoading(false);
    }
    }, [token, warehouseId]);

  const fetchShifts = useCallback(async () => {
    setLoading(true);
    try {
      // Получаем активные смены
      const resShifts = await axios.get(`${API_URL}/api/shifts?status=active`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const shiftsData = resShifts.data?.data || [];

      // Получаем активные склады
      const resStorages = await axios.get(`${API_URL}/api/storages?status=active`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const storagesData = resStorages.data?.data || [];

      // Мапим storage_id в название склада
      const storageMap = {};
      storagesData.forEach(s => {
        storageMap[s.id] = s.name;
      });

      // Форматируем смены для селекта
      const formattedShifts = shiftsData.map(shift => ({
        value: shift.id,
        label: storageMap[shift.storage_id] || `Склад ${shift.storage_id}`, // если нет названия
      }));

      setShifts(formattedShifts);
    } catch (err) {
      console.error("Ошибка загрузки смен:", err);
      setShifts([]);
    } finally {
      setLoading(false);
    }
  }, [token]);


  useEffect(() => {
    if (open) {
      fetchSuppliers();
      fetchWallets();
      fetchShifts();
    }
  }, [open, fetchSuppliers, fetchWallets, fetchShifts]);

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Завершенные приемки</h2>

        <label>Поставщик</label>
        <CustomSelect
          className={styles.filters__select}
          options={suppliers.map(s => ({ value: s.id, label: s.name }))}
          value={supplierId}
          onChange={setSupplierId}
          placeholder="Поставщик"
        />

        <label>Дата приемки</label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <label>Средство для оплаты</label>
        <CustomSelect
            className={styles.filters__select}
            options={wallets} // уже с правильными label
            value={paymentMethodId}
            onChange={setPaymentMethodId}
            placeholder="Средство для оплаты"
        />


        <label>Смена</label>
        <CustomSelect
          className={styles.filters__select}
          options={shifts}
          value={shiftId}
          onChange={setShiftId}
          placeholder="Смена"
        />


        <div className={styles.actions}>
          <button
              className={styles.later}
              onClick={() => {
                const payload = { supplierId, paymentMethodId, shiftId, date };
                console.log("🟡 [CompletedInvoiceModal] Оплатить позже → отправляем в родителя:", payload);
                onPayLater(payload);
              }}
            >
            Оплатить позже
            </button>

            <button
            className={styles.pay}
            onClick={() =>
                onPay({ supplierId, paymentMethodId, shiftId, date })
            }
            >
            Оплатить
            </button>
        </div>

        <span className={styles.close} onClick={onClose}>×</span>
      </div>
    </div>
  );
};

export default CompletedInvoiceModal;
